import ValidTriggerCheckValidationResultLabel from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/triggerChecks/ValidTriggerCheckValidationResultLabel';
import EnrollmentCheckValidationResultLabel from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/enrollmentChecks/EnrollmentCheckValidationResultLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationResultLabel = ({
  validationResult,
  flowRevision
}) => {
  if (validationResult.type === 'VALID_TRIGGER_CHECK') {
    return /*#__PURE__*/_jsx(ValidTriggerCheckValidationResultLabel, {
      validationResult: validationResult.result,
      flowRevision: flowRevision
    });
  }
  return /*#__PURE__*/_jsx(EnrollmentCheckValidationResultLabel, {
    validationResult: validationResult.result,
    flowRevision: flowRevision
  });
};
export default ValidationResultLabel;